// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Growth_wrapper__3u3_m","header":"Growth_header__2x8Gb"};